import CircularProgress from '@mui/material/CircularProgress';
import { FullStack } from './loading.styled';

const Loading = () => {
  return (
    <FullStack alignItems={'center'} justifyContent={'center'}>
      <CircularProgress />
    </FullStack>
  );
};

export default Loading;
